import { useState } from "react";
import { toastr } from "react-redux-toastr";
import { Button, ModalUpload } from "expano-components";
import { client } from "utils/api";

import { Dashboard } from "components";

export const uploadProductBrandingLabel = async (id, branding_label) => {
  try {
    const body = new FormData();
    body.append("branding_label", branding_label);
    await client.put(`/products/${id}`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    toastr.success("Sukces", "Etykieta została dodana");
  } catch (error) {
    toastr.error("Błąd", "Nie udało się wgrać etykiety");
    throw new Error(error.response?.data?.error);
  }
};

const BrandingInfo = ({ branding_label_url, product_id, refetch }) => {
  const [is_open, setOpen] = useState(false);
  const handleUpload = async (image) => {
    await uploadProductBrandingLabel(product_id, image);
    refetch();
  };
  return (
    <Dashboard
      header={{
        title: "Etykieta sprzedażowa",
        icon: "info",
        aside: <Button type="add" text="Dodaj" onClick={() => setOpen(true)} />,
      }}
    >
      {is_open && (
        <ModalUpload
          headerText="Wgraj etykietę sprzedażową"
          handleUpload={handleUpload}
          handleClose={() => setOpen(false)}
          name={`etykietę`}
          limit={1}
        />
      )}
      {branding_label_url && (
        <div style={{ padding: 20, textAlign: "center" }}>
          <img src={branding_label_url} alt="" style={{ maxWidth: "100%" }} />
        </div>
      )}
    </Dashboard>
  );
};

export default BrandingInfo;
